import { createInstance, type ReactSDKClient } from '@optimizely/react-sdk';

import { newRelic } from '../newRelic/newRelic';

declare global {
  interface Window {
    _optimizelyClient: ReactSDKClient | undefined;
  }
}

/*
 * `CONFIG` is globally declared in `custom_typings`, which the isolated module
 * typecheck (`app/isolated/modules/tsconfig.json`) deliberately excludes. This
 * file is part of the isolated modules dependency graph (through `decideFeatureFlag`,
 * whitelisted in `ISOLATED_MODULE_ALLOWED_HOST_FILES`), so it re-declares the slice of
 * `CONFIG` it needs. Keep this file's import graph lean: anything imported
 * here is typechecked without the host custom typings.
 */
declare const CONFIG: { optimizely: { sdkKey: string } };

/**
 * errorHandler is an object that contains a method called handleError.
 * This method is used to handle errors thrown in Optimizely SDK.
 * It takes an Error object as a parameter and sends the error stack trace to New Relic.
 */
const errorHandler = {
  handleError: (error: Error) => {
    newRelic.noticeError('Optimizely error', { error });
  },
};

const WARNING = 3;
export const optimizelyClient = createInstance({
  datafileOptions: {
    autoUpdate: true,
  },
  errorHandler,
  eventBatchSize: 10,
  eventFlushInterval: 1000,
  logLevel: WARNING,
  sdkKey: CONFIG.optimizely.sdkKey,
});
window._optimizelyClient = optimizelyClient;
